<template>
    <div>
        <v-card class="mt-2" v-show="this.requiredQuestions.length>0">
           <v-card-title class="subtitle-1">{{$t('labels.CLI_HealthQuestions')}}</v-card-title>
           <v-card-text>
                 <v-row>
                       <v-col lg="6" sm="12" md="6"></v-col>
                       <v-col lg="3" sm="6" md="3" v-for="item in applicants" v-bind:key="item.ApplicatId">
                            <span class="font-weight-black"  v-if="item.PrimaryFl" >{{item.FirstName}} {{item.LastName}}</span> 
                            <span class="font-weight-black"  v-if="!item.PrimaryFl" >{{item.FirstName}} {{item.LastName}}</span>                                         
                        </v-col>
                     </v-row>
                <template v-for="(question, index) in requiredQuestions">             
                    <v-row v-bind:key="index">
                            <v-col lg="12" sm="12" md="12">
                                <span class="font-weight-regular required"><strong>{{$t("labels.CLI_Question") + " " + question + ":"}}</strong></span>
                            </v-col>
                            <v-col cols="12" lg="6" sm="12" md="6">
                                <v-row class="ml-2 mr-2">
                                   <v-col class="col-12">
                                        <p>{{$t("labels.CLI_HealthQuestion_" + (index +1))}}</p>
                                        <ul v-if="index == 0">
                                            <li>{{$t("labels.CLI_HealthQuestion_1_sub_1")}}</li>
                                            <li>{{$t("labels.CLI_HealthQuestion_1_sub_2")}}</li>
                                            <li>{{$t("labels.CLI_HealthQuestion_1_sub_3")}}</li>
                                        </ul>  
                                    </v-col>  
                                </v-row>
                            </v-col>
                            <v-col lg="3" sm="6" md="3" v-for="item in applicants" v-bind:key="item.ApplicatId">
                                <v-radio-group row v-model="item.HealthQuestions[question-1].Answer" :rules="[v=>!!v || '']" v-if="showAnswer(item, question)">
                                    <v-radio :label="$t('labels.CLI_Yes')" value="Y"></v-radio>
                                    <v-radio :label="$t('labels.CLI_No')" value="N"></v-radio>
                                </v-radio-group>  
                                <span v-show="!showAnswer(item, question)" class="font-weight-regular">{{$t('labels.CLI_NotApplicable')}}</span>                           
                            </v-col>   
                    </v-row>         
                    
                </template>
          </v-card-text>
         </v-card>    
          <!-- <div class="row">{{applicants}}</div>      -->
    </div>
</template>
<script>

export default {
    name:"healthQuestions",   
     props:["applicants"],
     data(){
       return{
           isSubmitted:false,
           questions:["1", "2", "3", "4", "5"],
           requiredQuestions:[]
       }
    },
    created(){
        this.reset()
   },

    methods:{
        reset(){
               let selectedCoverageTypes = []
                for(let index=0; index<this.applicants.length; index++){
                    let applicant = this.applicants[index];
                    for(let cindex=0; cindex<applicant.InsuranceTypes.length; cindex++){
                        let insuranceType = applicant.InsuranceTypes[cindex]
                        if(insuranceType.SelectedFl){
                            if(!selectedCoverageTypes.includes(insuranceType.Code)){
                                selectedCoverageTypes.push(insuranceType.Code)
                            }
                        }
                    }
                }
                
                let healthQuestions = this.applicants[0].HealthQuestions;
                 this.requiredQuestions = [];
                healthQuestions.forEach(hq=>{
                    if(selectedCoverageTypes.includes(hq.CoverageCode)){
                        this.requiredQuestions.push(hq.Question)
                    }
                }) 
                
                  this.applicants.forEach(applicant => {
                    applicant.HealthQuestions.forEach(question=>{
                        question.Answer = ""
                    })
                });
        },

       showAnswer(applicant, question){
            return this.getQuestion(applicant, question) !== null;
       },
       getQuestion(applicant, question){
          var selectedQuestion = applicant.HealthQuestions.filter(function(q){
              return q.Question === question
          });         
         
           var answerRequired =  applicant.InsuranceTypes.some(function(it){
                 return selectedQuestion[0].CoverageCode === it.Code && it.SelectedFl 
            });
           
           if(answerRequired){
               return selectedQuestion[0];
           }         
          return null;
       }      
   }, 
}
</script>
<style  scoped>
 
</style>